export default "__VITE_ASSET__CEGioOVl__"